import {
  loginUsuarioExterno,
  setLoadingUsuarioExterno,
  userSelector,
} from "features/User/redux/slices/userSlice"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"

const useFactura = () => {
  const [comesFromMdf, setComesFromMdf] = useState(false)

  const { empresaActiva, id, loadingUsuarioExterno } = useSelector(userSelector)
  const [librador, setLibrador] = useState(empresaActiva)

  const dispatch = useDispatch()
  const params = useParams()

  const { cif, email, identityId, razonSocial, libradorMdfId } = params

  useEffect(() => {
    setLibrador({
      ...empresaActiva,
      creadorId: id,
      libradorMdfId,
    })
  }, [dispatch, empresaActiva, id, libradorMdfId])

  useEffect(() => {
    if (cif && email && identityId && razonSocial) {
      setComesFromMdf(true)
      dispatch(
        // @ts-expect-error TS(2554): Expected 0 arguments, but got 1.
        loginUsuarioExterno({
          cif,
          email,
          identityId,
          razonSocial,
        })
      )
    } else {
      dispatch(setLoadingUsuarioExterno(false))
    }
  }, [cif, email, identityId, razonSocial, dispatch])

  return {
    comesFromMdf,
    librador,
    loadingUsuarioExterno,
  }
}

export default useFactura
